// src/components/AdminLogin.jsx
import React, { useState } from 'react';
import { verifyAdminPassword } from '../lib/api';

const SESSION_KEY = 'jic_admin_auth';

export function isAuthenticated() {
  return sessionStorage.getItem(SESSION_KEY) === 'true';
}

export function logout() {
  sessionStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem('jic_admin_pass');
}

export default function AdminLogin({ onLogin }) {
  const [pass, setPass]       = useState('');
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const ok = await verifyAdminPassword(pass);
    setLoading(false);
    if (ok) {
      // Heslo se ukládá až po ověření serverem – nikdy není v JS bundlu
      sessionStorage.setItem('jic_admin_pass', pass);
      sessionStorage.setItem(SESSION_KEY, 'true');
      onLogin();
    } else {
      setError('Nesprávné přihlašovací údaje.');
    }
  }

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      minHeight: 'calc(100vh - 56px)',
      background: '#fafafa',
    }}>
      <form
        onSubmit={handleSubmit}
        style={{
          background: '#fff',
          border: '1px solid rgba(91,20,179,0.15)',
          borderRadius: 12,
          padding: '40px 48px',
          width: '100%',
          maxWidth: 360,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        <h2 style={{ margin: 0, color: '#5b14b3', fontSize: 20, fontWeight: 600 }}>
          Admin přihlášení
        </h2>

        <label style={labelStyle}>
          Heslo
          <input
            type="password"
            value={pass}
            onChange={e => setPass(e.target.value)}
            autoComplete="current-password"
            required
            style={inputStyle}
          />
        </label>

        {error && (
          <p style={{ margin: 0, color: '#c0392b', fontSize: 13 }}>{error}</p>
        )}

        <button type="submit" disabled={loading} style={btnStyle}>
          {loading ? 'Ověřuji…' : 'Přihlásit se'}
        </button>
      </form>
    </div>
  );
}

const labelStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  fontSize: 13,
  fontWeight: 500,
  color: '#333',
};

const inputStyle = {
  padding: '8px 12px',
  border: '1px solid rgba(91,20,179,0.25)',
  borderRadius: 6,
  fontSize: 14,
  outline: 'none',
  fontFamily: 'inherit',
};

const btnStyle = {
  marginTop: 4,
  padding: '10px 0',
  background: '#5b14b3',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  fontSize: 14,
  fontWeight: 600,
  cursor: 'pointer',
  fontFamily: 'inherit',
};
